import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

const flexStyles = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Container = styled.div`
  ${({ mobile }) =>
    !mobile &&
    css`
      display: grid;
      gap: 0.5rem;
    `}

  ${({ mobile }) => !!mobile && flexStyles}

  ${breakpoint("tablet")`
    ${flexStyles}
  `}
`
